import React from "react";

const INITIAL_FORM = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  gender: "Male",
  contactNo: "",
};

const ManualTab = ({ form, onChange, onSubmit, loading }) => (
  <div className="mb-6">
    <p className="text-sm text-gray-600 mb-3">
      Add one dummy user. Email must end with <strong>@naseebi.com</strong>. Other fields are optional.
    </p>
    <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">First name</label>
        <input
          type="text"
          value={form.firstName}
          onChange={(e) => onChange({ ...form, firstName: e.target.value })}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
          placeholder="User"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Last name</label>
        <input
          type="text"
          value={form.lastName}
          onChange={(e) => onChange({ ...form, lastName: e.target.value })}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
          placeholder="Dummy"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Email * (@naseebi.com)</label>
        <input
          type="email"
          value={form.email}
          onChange={(e) => onChange({ ...form, email: e.target.value })}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
          placeholder="e.g. testuser@naseebi.com"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Password *</label>
        <input
          type="password"
          value={form.password}
          onChange={(e) => onChange({ ...form, password: e.target.value })}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
          placeholder="Min 6 characters"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Gender</label>
        <select
          value={form.gender}
          onChange={(e) => onChange({ ...form, gender: e.target.value })}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
        >
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Contact (optional)</label>
        <input
          type="text"
          value={form.contactNo}
          onChange={(e) => onChange({ ...form, contactNo: e.target.value })}
          className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm"
          placeholder="+92..."
        />
      </div>
      <div className="md:col-span-2">
        <button
          type="submit"
          disabled={loading}
          className="rounded-lg border border-red-500 bg-red-500 px-4 py-2 text-sm font-semibold text-white hover:bg-red-600 disabled:opacity-50"
        >
          {loading ? "Creating…" : "Create dummy user"}
        </button>
      </div>
    </form>
  </div>
);

export default ManualTab;
export { INITIAL_FORM };
